import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import { useSvgId } from '../../primitives/useSvgId.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Zap — strike of lightning. When `active`, a vertical highlight sweeps
 *  the bolt (clipped), then the body flashes. CSS hover adds a drop-shadow. */
export function IcnZap(props: AnimatedIconProps): ReactNode {
  const { active = false, ...rest } = props;
  const reduced = useReducedMotion();
  const clipId = useSvgId('zap-clip');
  const path = 'M9 2L3.5 9h3.5L7 14l5.5-7H9L9 2z';
  return (
    <Svg {...rest} iconName="zap" data-on={active ? 'true' : 'false'}>
      <defs>
        <clipPath id={clipId}>
          <path d={path} />
        </clipPath>
      </defs>
      <path d={path} fill="currentColor" stroke="none">
        {active && !reduced && (
          <animate
            attributeName="opacity"
            values="0.85;1;0.85"
            dur="0.6s"
            repeatCount="indefinite"
          />
        )}
      </path>
      {active && !reduced && (
        <g clipPath={`url(#${clipId})`}>
          <line
            x1="-2"
            y1="16"
            x2="4"
            y2="0"
            stroke="var(--vq-paper-raised, #fff)"
            strokeWidth="2"
            opacity="0.7"
          >
            <animate attributeName="x1" values="-4;14" dur="0.9s" repeatCount="indefinite" />
            <animate attributeName="x2" values="2;20" dur="0.9s" repeatCount="indefinite" />
            <animate
              attributeName="opacity"
              values="0;0.85;0"
              keyTimes="0;0.5;1"
              dur="0.9s"
              repeatCount="indefinite"
            />
          </line>
        </g>
      )}
    </Svg>
  );
}
